<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 v-for="item of appointments" :key="item.externalId">
      <v-card :class="item.visitStatus">
        <v-card-title primary-title>
          <div>
            <v-flex text-xs-left>
              <b>{{item.visitTime}}</b>
            </v-flex>
            <v-flex text-xs-left>
              <b>{{item.clientPhone}}</b> {{item.clientName}}
            </v-flex>
            <v-flex text-xs-left>
              <span v-for="service of item.services" :key="service.id">
                {{ service.title }}
                <br>
              </span>
            </v-flex>
            <v-flex text-xs-left>
              <a :href="'http://' + item.shortLink" target="_blank">{{item.shortLink}}</a>
            </v-flex>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-flex text-xs-left>
            <v-btn v-if="!item.isSmsSent" color="#4169E1" style="color:white" @click="sendSms(item.yclientsId)" title="Отправить">
              <v-icon>send</v-icon>
            </v-btn>
            <v-btn v-if="item.isSmsSent" color="#4169E1" style="color:white" @click="sendSms(item.yclientsId)" disabled title="Отправлено">
              <v-icon>send</v-icon>
            </v-btn>
          </v-flex>

          <v-flex text-xs-right>
            <v-avatar size="" color="grey lighten-4">
              <img :src="item.staffImg" alt="avatar" :title="item.staffName">
            </v-avatar>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped>
  .v-avatar img {
    height: 40px;
    width: 40px;
    border: 1px solid #333;
  }
  .waiting {
    background-color: rgba(255, 209, 102, 0.5) !important
  }
  .confirmed {
    background-color: rgba(51, 221, 177, 0.5) !important
  }
  .canceled {
    background-color: rgba(239, 71, 111, 0.5) !important
  }
  .edited {
    background-color: rgba(128, 128, 128, 0.5) !important
  }
  .canceled, .confirmed, .waiting, .edited {
    margin-bottom: 10px
  }
</style>

<script>
import SyncDataLogic from './SyncDataLogic'

export default {
  extends: SyncDataLogic
}
</script>
